<template>
	<component
		:is="View"
		v-bind="wrapperProps"
		class="verify-flow"
		:class="{ 'next-animate': nowNext, 'prev-animate': nowPrev }"
	>
		<template v-slot:title>
			<div class="header">
				<IconClose class="header-icon-close" v-if="content?.allowClose" @click="handleCancel" />
				<IconLeftArrow class="header-icon-left-arrow" v-if="content?.allowBack" @click="handleBack" />
				<span class="header-skip" v-if="content?.showSkip" @click="handleNext">{{
					$t('common-verify-flow.skip')
				}}</span>
			</div>
		</template>
		<Transition name="slide-up" mode="out-in" appear v-if="content">
			<component
				:is="content.component"
				@next="handleNext"
				:supoprted-countries="supoprtedCountries"
				:require-kyc2="requirKyc2"
				@cancel="handleCancel"
			/>
		</Transition>
	</component>
</template>

<script>
import twemoji from 'twemoji';
import Cookies from 'js-cookie';
import { countryNameMap } from '../../helper/country-name';
import messages from './i18n';
import { components, componentsChain } from './map';
import { axiosClient } from '~/common/js/axios';
import { isLoginedToken } from '~/common/js/utils';
import IconClose from './img/close.svg';
import IconLeftArrow from './img/leftArrow.svg';
import { usePatchStore } from '~/common/js/patch';
import { ElDialog, ElDrawer } from 'element-plus';

export default {
	i18n: { messages },
	name: 'VerifyKycFlow',
	props: {
		kycLevel: {
			// kyc 认证的信息
			type: Number,
			default: 0,
		},
		// requirKyc2: {
		//   type: Boolean,
		//   default: false,
		// },
	},
	data() {
		return {
			current: 0,
			global: null,
			nowNext: false,
			nowPrev: false,
			supoprtedCountries: [],
		};
	},
	components: { ...components, IconLeftArrow, IconClose },
	computed: {
		locale() {
			return this.store.locale;
		},
		showVerifyKycFlow() {
			return this.store.newVerifyKycFlow.showVerifyKycFlow;
		},
		targetKycLevel() {
			return this.store.newVerifyKycFlow.targetKycLevel;
		},
		startKycLevel() {
			return this.store.newVerifyKycFlow.startKycLevel;
		},
		View() {
			if (!this.global) {
				return ElDialog;
			}
			if (this.global.screen.width > 768) {
				return ElDialog;
			} else {
				return ElDrawer;
			}
		},
		chains() {
			if (!this.showVerifyKycFlow) {
				return [];
			}
			const list = [];
			const { _PrimaryVerification, _Result, _Continue, _SeniorVerification, _Authorize } = componentsChain;
			if (this.startKycLevel === -1) {
				// QR authorize 二维码授权流程
				list.push(_Authorize);
			}
			if (this.startKycLevel === 0) {
				list.push(_PrimaryVerification, _Result);
			}
			if (this.targetKycLevel === 2) {
				if (this.startKycLevel === 1) {
					_Continue.allowBack = false;
				}
				list.push(_Continue);
				list.push(_SeniorVerification);
			}
			list.push(_PrimaryVerification, _Result);
			return list;
		},
		content() {
			//  PrimaryVerification SeniorVerification Continue Result
			return this.chains[this.current];
		},
		wrapperProps() {
			if (this.View === 'el-drawer') {
				return {
					'model-value': this.visible,
					beforeClose: this.beforeClose,
					direction: 'btt',
					class: 'drawer',
					showClose: false,
					...(this.content?.['el-drawer'] ?? {}),
				};
			} else {
				return {
					class: 'verify-flow-dialog',
					'model-value': this.visible,
					beforeClose: this.beforeClose,
					showClose: false,
					...(this.content?.['el-dialog'] ?? {}),
					'close-on-click-modal': false,
				};
			}
		},
		requirKyc2() {
			return this.targetKycLevel >= 2;
		},
		visible() {
			return this.showVerifyKycFlow && this.targetKycLevel > this.startKycLevel && this.targetKycLevel <= 2;
		},
	},
	watch: {
		visible(nv, ov) {
			if (nv === true && ov === false && this.supoprtedCountries.length < 1) {
				this.getSupportCountryList();
			}
		},
	},
	methods: {
		getSupportCountryList() {
			if (!isLoginedToken()) {
				return;
			}
			axiosClient({
				method: 'GET',
				url: '/gw-api/user-center/kyc/country/supported',
				// headers: {
				// 	Authorization: Cookies.get('accessToken'),
				// },
			}).then((res) => {
				const countryList = res?.data?.countryList || [];
				const supoprtedCountries = [];
				countryList.forEach((countryCode) => {
					const country = { ...countryNameMap[countryCode] };
					if (country) {
						country.flag = twemoji.parse(country.flag, {
							base: import.meta.env.TWEMOJI_CDN,
						});
						supoprtedCountries.push(country);
					}
				});
				this.supoprtedCountries = supoprtedCountries;
			});
		},
		show() {
			// this.visible = true
		},
		hide() {
			this.commit('VERIFY_KYC_FLOW_END');
			this.$emit('finish');
			this.current = 0;
		},
		handleNext() {
			if (this.current + 1 === this.chains.length) {
				return;
			}
			this.nowNext = true;
			this.nowPrev = false;
			++this.current;
			// console.log('next');
		},
		handleBack() {
			if (this.current === 0) {
				return;
			}
			this.nowNext = false;
			this.nowPrev = true;
			--this.current;
			// console.log('后退');
		},
		handleCancel() {
			this.$emit('cancel');
			this.commit('VERIFY_KYC_FLOW_END');
			this.current = 0;
		},
		beforeClose() {
			this.commit('VERIFY_KYC_FLOW_END');
			this.current = 0;
		},
		handleClose() {},
	},

	mounted() {
		this.global = window;
		// 查询可选国家列表
		this.getSupportCountryList();
	},
	setup() {
		const { store, commit } = usePatchStore();
		return {
			store,
			commit,
		};
	},
};
</script>

<style lang="less">
.day-mode {
	--comp-verify-flow-dialog-text: #1a1b1f;
	--comp-verify-flow-dialog-bg: #ffffff;
}

.night-mode {
	--comp-verify-flow-dialog-text: #ffffff;
	--comp-verify-flow-dialog-bg: #2a2d37;
}
</style>
<style lang="less">
.verify-flow {
	&.next-animate {
		.slide-up-enter {
			opacity: 0;
			transform: translateX(15px);
		}

		.slide-up-leave-to {
			opacity: 0;
			transform: translateX(-15px);
		}
	}
	&.prev-animate {
		.slide-up-enter {
			opacity: 0;
			transform: translateX(-15px);
		}

		.slide-up-leave-to {
			opacity: 0;
			transform: translateX(15px);
		}
	}
	.slide-up-enter-active,
	.slide-up-leave-active {
		transition: all 0.25s ease-out;
	}

	&.el-drawer.drawer {
		overflow: hidden;
		border-radius: 16px 16px 0px 0px;
		.el-drawer__header {
			overflow: hidden;
			padding: 0;
		}
	}
	&.el-dialog {
		width: 90%;
		max-width: 720px;
		border-radius: 8px;
	}

	.el-form-item.is-error .VF__input {
		border: 1px solid #ff4d4f;
	}

	.el-form-item__error {
		padding-top: 0px;
		top: 96%;
	}

	&.el-dialog.verify-flow-dialog {
		background-color: var(--comp-verify-flow-dialog-bg, #fff);
	}
	&.el-dialog.verify-flow-dialog .el-dialog__header {
		// padding: 0;
		// padding-bottom: 10px;
    padding: 20px 20px 13px !important;
		margin-right: 0px;
	}

	.el-dialog__body,
	.el-dialog--center .el-dialog__body {
		padding: 0 40px 40px;
	}
}
</style>
<style lang="less" scoped>
@media (min-width: 768px) {
	.el-dialog__header {
		padding: 0;
	}
	.header {
		display: flex;
		justify-content: space-between;
		flex-direction: row-reverse;
		&-skip {
			cursor: pointer;
			font-size: 14px;
			font-weight: 400;
			color: #13c2c2;
		}

		&-icon-close,
		&-icon-left-arrow {
			width: 16px;
			path {
				fill: var(--comp-verify-flow-dialog-text, #1a1b1f);
			}
		}

		img {
			width: 20px;
			height: 20px;
		}
	}
}
@media (max-width: 767px) {
	.header {
		padding: 0 0 0.4em 0;
		display: flex;
		justify-content: space-between;
		flex-direction: row-reverse;
		&-skip {
			cursor: pointer;
			font-size: 14px;
			font-weight: 400;
			color: #13c2c2;
		}
		&-icon-close,
		&-icon-left-arrow {
			width: 16px;
			path {
				fill: var(--comp-verify-flow-dialog-text, #1a1b1f);
			}
		}
		img {
			width: 1em;
			height: 1em;
		}
	}
}
</style>
